'use client';

import { Header } from './_PageSections/Header';
import { LayoutProps } from '@/lib/types/types';
import Footer from '@/components/Footer';
import { usePathname } from 'next/navigation';

export default function MarketingLayout({ children }: LayoutProps) {
  const pathname = usePathname();
  const isFullPage = pathname === '/faq' || pathname.includes('/track_shipment');

  return (
    <div className="h-screen bg-brand-gradient">
      <div>
        <Header />
      </div>
      {isFullPage ? (
        <main className="w-full pt-20">{children}</main>
      ) : (
        <main className="grid items-center justify-center pt-20">{children}</main>
      )}
      <Footer />
    </div>
  );
}
